import type { Game } from "@/types/game";

// CDN for HTML games (GitHub Pages)
const GH_CDN = "https://mattiasmicu.github.io/notsocrazy/public";

// Unity games use relative paths so Vercel serves them with correct headers
// HTML games use GitHub Pages CDN to save Vercel bandwidth

export const games: Game[] = [
  {
    id: "unity-1777352809967-space-waves",
    title: "Space Waves",
    description: "Space Waves is an arcade game where you need to control an arrow to avoid obstacles until you get to the end. There are 33 levels to the game, and you can choose any level you want to play at any time.",
    category: "Other",
    rating: 4.263653297403672,
    plays: 2,
    path: "/public/games/unity-1777352809967-space-waves/index.html",
  },
  {
    id: "unity-1777352816216-traffic-rider-vvq",
    title: "Traffic Rider",
    description: "Traffic Rider is a first-person driving bike endless game that puts you on a motorbike for an exhilarating ride.",
    category: "Other",
    rating: 4.73862736865367,
    plays: 2,
    path: "/public/games/unity-1777352816216-traffic-rider-vvq/index.html",
  },
  {
    id: "html-1777352823508-rocketgoal-io",
    title: "RocketGoal.io",
    description: "RocketGoal.io is an IO sports game where you drive around a soccer field to compete in intense matches against other players.",
    category: "Other",
    rating: 4.324661470306053,
    plays: 2,
    path: `${GH_CDN}/games/html-1777352823508-rocketgoal-io/index.html`,
  },
  {
    id: "html-1777352826254-open-house",
    title: "Open House",
    description: "Open House is a puzzle match-3 game where you're unexpectedly tasked with turning an abandoned residence into your dream home.",
    category: "Other",
    rating: 4.961518729202038,
    plays: 2,
    path: `${GH_CDN}/games/html-1777352826254-open-house/index.html`,
  },
  {
    id: "unity-1777352836146-sky-riders-buk",
    title: "Sky Riders",
    description: "Sky Riders is a high-speed casual vehicle driving game. Put your driving skills to the test as you complete several challenging tracks.",
    category: "Other",
    rating: 4.819683132363033,
    plays: 2,
    path: "/public/games/unity-1777352836146-sky-riders-buk/index.html",
  },
  {
    id: "html-1777352840674-8-ball-pool-billiards-multiplayer",
    title: "8 Ball Pool Billiards Multiplayer",
    description: "8 Ball Pool Billiards Multiplayer is a competitive sports pool game that lets you test your skills in exhilarating 2-player matches.",
    category: "Other",
    rating: 4.683481302856724,
    plays: 2,
    path: `${GH_CDN}/games/html-1777352840674-8-ball-pool-billiards-multiplayer/index.html`,
  },
  {
    id: "unity-1777352843881-farm-ring-idle",
    title: "Farm Ring Idle",
    description: "Farm Ring Idle is a circular farming simulation that challenges you to expand outward from a tiny central plot into a thriving, automated ring of crops.",
    category: "Other",
    rating: 4.247649563705637,
    plays: 2,
    path: "/public/games/unity-1777352843881-farm-ring-idle/index.html",
  },
  {
    id: "html-1777352847510-worldguessr",
    title: "WorldGuessr | Free GeoGuessr",
    description: "Worldguessr is a casual quiz game, a free alternative to Geoguessr, perfect for testing and expanding your geography skills.",
    category: "Other",
    rating: 4.329416879177341,
    plays: 2,
    path: `${GH_CDN}/games/html-1777352847510-worldguessr/index.html`,
  },
  {
    id: "unity-1777352850784-rally-racer-dirt",
    title: "Rally Racer Dirt",
    description: "Rally Racer Dirt is a rally drift-based game that allows you to drift on both asphalt and dirt terrains while navigating through hills.",
    category: "Other",
    rating: 4.309419324557102,
    plays: 2,
    path: "/public/games/unity-1777352850784-rally-racer-dirt/index.html",
  },
  {
    id: "unity-1777352857850-basketball-orbit",
    title: "Basketball Orbit",
    description: "Basketball Orbit is an exhilarating sports basketball simulation game where you aim to launch basketballs to unbelievable heights.",
    category: "Other",
    rating: 4.788895939814804,
    plays: 2,
    path: "/public/games/unity-1777352857850-basketball-orbit/index.html",
  },
  {
    id: "unity-1777352861637-super-star-car",
    title: "Super Star Car",
    description: "Super Star Car is a driving Formula 1 racing game that puts you in the driver's seat of high-speed action.",
    category: "Other",
    rating: 4.026467281933127,
    plays: 2,
    path: "/public/games/unity-1777352861637-super-star-car/index.html",
  },
  {
    id: "unity-1777352870850-mini-golf-club",
    title: "Mini Golf Club",
    description: "Mini Golf Club is a realistic 3D mini golf simulator with fun gameplay and hundreds of challenging levels.",
    category: "Other",
    rating: 4.431728542491728,
    plays: 3,
    path: "/public/games/unity-1777352870850-mini-golf-club/index.html",
  },
  {
    id: "unity-1777352983096-mr-racer---car-racing",
    title: "Mr. Racer - Car Racing",
    description: "Mr Racer - Car Racing is a fast-paced driving game where you speed through traffic-packed streets in sleek supercars.",
    category: "Other",
    rating: 4.359819992742802,
    plays: 2,
    path: "/public/games/unity-1777352983096-mr-racer---car-racing/index.html",
  },
  {
    id: "unity-1777352987285-racing-limits",
    title: "Racing Limits",
    description: "Racing Limits is a racing game that lets you push your skills to the max.",
    category: "Other",
    rating: 4.59507220367655,
    plays: 2,
    path: "/public/games/unity-1777352987285-racing-limits/index.html",
  },
  {
    id: "unity-1777352998344-mx-offroad-master",
    title: "MX Offroad Master",
    description: "MX Offroad Master is a driving bike game where you cycle down steep mountain slopes.",
    category: "Other",
    rating: 4.15674266475231,
    plays: 2,
    path: "/public/games/unity-1777352998344-mx-offroad-master/index.html",
  },
  {
    id: "unity-1777353003870-sandbox-city---cars-zombies-ragdolls",
    title: "Sandbox City",
    description: "Sandbox City - Cars, Zombies, Ragdolls! is a zombie game where you can explore freely and drive around the city.",
    category: "Other",
    rating: 4.8677146485429965,
    plays: 2,
    path: "/public/games/unity-1777353003870-sandbox-city---cars-zombies-ragdolls/index.html",
  },
  {
    id: "unity-1777353019951-doodle-road",
    title: "Doodle Road",
    description: "Doodle Road is an imaginative 2D casual game that combines creativity with problem-solving.",
    category: "Other",
    rating: 4.973651754544181,
    plays: 2,
    path: "/public/games/unity-1777353019951-doodle-road/index.html",
  },
  {
    id: "unity-1777353029986-ramp-car-vs-police-chase-psm",
    title: "Ramp Car VS Police: CHASE",
    description: "Experience a dangerous police chase as you drive a ramp car or a wedge truck through chaotic traffic.",
    category: "Other",
    rating: 4.947499812709678,
    plays: 2,
    path: "/public/games/unity-1777353029986-ramp-car-vs-police-chase-psm/index.html",
  },
  {
    id: "unity-1777353035200-driving-school-simulator",
    title: "Driving School Simulator",
    description: "Driving School Simulator is a simulation driving game that puts your skills to the test.",
    category: "Other",
    rating: 4.947410148233839,
    plays: 2,
    path: "/public/games/unity-1777353035200-driving-school-simulator/index.html",
  },
  {
    id: "unity-1777353055132-escape-road-asm",
    title: "Escape Road",
    description: "Escape Road is a getaway driving game that will get your adrenaline pumping.",
    category: "Other",
    rating: 4.490013948503884,
    plays: 2,
    path: "/public/games/unity-1777353055132-escape-road-asm/index.html",
  },
  {
    id: "unity-1777353345386-escape-road-2",
    title: "Escape Road 2",
    description: "Escape Road 2 is a fast-paced driving game that throws you into a high-speed chase with law enforcement after a bank heist.",
    category: "Other",
    rating: 4.772514892777115,
    plays: 2,
    path: "/public/games/unity-1777353345386-escape-road-2/index.html",
  },
  {
    id: "html-1777353414239-bloxdhop-io",
    title: "Bloxd io",
    description: "Bloxd.io is an IO adventure game with Minecraft-style visuals where you can navigate obstacle courses and battle other players.",
    category: "Other",
    rating: 4.673976275811827,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353414239-bloxdhop-io/index.html`,
  },
  {
    id: "unity-1777353417559-hazmob-fps-online-shooter",
    title: "Hazmob FPS: Online Shooter",
    description: "Hazmob FPS: Online Shooter is a multiplayer shooting FPS game where every second counts!",
    category: "Other",
    rating: 4.502870760133082,
    plays: 2,
    path: "/public/games/unity-1777353417559-hazmob-fps-online-shooter/index.html",
  },
  {
    id: "html-1777353426048-tileman-io",
    title: "TileMan.io",
    description: "TileMan.io is an awesome multiplayer IO game in which you must try to claim as much territory as possible.",
    category: "Other",
    rating: 4.603052837591642,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353426048-tileman-io/index.html`,
  },
  {
    id: "unity-1777353438299-squid-game-online",
    title: "Squid Game Online",
    description: "Squid Game Online is a free multiplayer survival game. Compete in 7 minigames with 30 players.",
    category: "Other",
    rating: 4.651540092023903,
    plays: 30,
    path: "/public/games/unity-1777353438299-squid-game-online/index.html",
  },
  {
    id: "html-1777353448657-openfront-gsw",
    title: "Openfront",
    description: "Openfront.io is an IO battle game where you expand your territory, build up your economy, and drop bombs to dominate the map.",
    category: "Other",
    rating: 4.8708942563526705,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353448657-openfront-gsw/index.html`,
  },
  {
    id: "unity-1777353453630-buildnow-gg",
    title: "BuildNow GG",
    description: "The official web location for BuildNow GG, an online build-and-shoot game featuring various game modes, weapons, and maps.",
    category: "Other",
    rating: 4.795897046355738,
    plays: 6,
    path: "/public/games/unity-1777353453630-buildnow-gg/index.html",
  },
  {
    id: "html-1777353458932-frontwars-io",
    title: "FrontWars.io",
    description: "FrontWars.io is a multiplayer .io battle game where players battle it out to dominate as much of the globe as possible.",
    category: "Other",
    rating: 4.430314209797023,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353458932-frontwars-io/index.html`,
  },
  {
    id: "unity-1777353462089-skillwarz",
    title: "SkillWarz",
    description: "SkillWarz is a fast-paced first-person shooter offering advanced movement mechanics and diverse game modes.",
    category: "Other",
    rating: 4.931653898256167,
    plays: 2,
    path: "/public/games/unity-1777353462089-skillwarz/index.html",
  },
  {
    id: "html-1777353467765-99-nights-bloxd-io",
    title: "99 Nights (Bloxd.io)",
    description: "99 Nights is an action-adventure game where your survival skills are put to the test.",
    category: "Other",
    rating: 4.7788969664300724,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353467765-99-nights-bloxd-io/index.html`,
  },
  {
    id: "unity-1777353470822-mr-dude-online-multiverse-challenge",
    title: "Mr. Dude: Online Multiverse Challenge",
    description: "Mr. Dude: Online Multiverse Challenge is a fun multiplayer game.",
    category: "Other",
    rating: 4.435375648559772,
    plays: 2,
    path: "/public/games/unity-1777353470822-mr-dude-online-multiverse-challenge/index.html",
  },
  {
    id: "html-1777353474687-escape-tsunami-for-brainrots-wfe",
    title: "Escape Tsunami for Brainrots!",
    description: "Escape Tsunami for Brainrots is a multiplayer game where you race to collect Brainrots before a massive wave destroys you.",
    category: "Other",
    rating: 4.44808882194455,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353474687-escape-tsunami-for-brainrots-wfe/index.html`,
  },
  {
    id: "html-1777353477985-meeland-io",
    title: "Meeland.io",
    description: "Meeland.io is a growing game-mode platform that invites you to build wealth through its lively Pet Tycoon experience.",
    category: "Other",
    rating: 4.396293208645584,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353477985-meeland-io/index.html`,
  },
  {
    id: "html-1777353480737-grow-a-garden---growden-io",
    title: "Grow a Garden | Growden.io",
    description: "Growden.io is an .io farming game where you manage a small plot of land.",
    category: "Other",
    rating: 4.423257338589057,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353480737-grow-a-garden---growden-io/index.html`,
  },
  {
    id: "unity-1777353529374-jelly-dash-uki",
    title: "Jelly Dash",
    description: "Jelly Dash is a fast-paced multiplayer racing game where gooey, jelly-like characters swing, stretch, and dash to the finish line!",
    category: "Other",
    rating: 4.539493020088534,
    plays: 2,
    path: "/public/games/unity-1777353529374-jelly-dash-uki/index.html",
  },
  {
    id: "html-1777353815024-basketbros",
    title: "BasketBros",
    description: "BasketBros is a fast-paced basketball game that offers both online and offline gameplay.",
    category: "Other",
    rating: 4.583755900231723,
    plays: 2,
    path: `${GH_CDN}/games/html-1777353815024-basketbros/index.html`,
  },
  {
    id: "unity-1777353823782-basketball-superstars",
    title: "Basketball Superstars",
    description: "Basketball Superstars is a dynamic basketball experience where you create and train your ultimate player.",
    category: "Other",
    rating: 4.08987986128389,
    plays: 2,
    path: "/public/games/unity-1777353823782-basketball-superstars/index.html",
  },
  {
    id: "unity-1777353828014-unmatched-basketball",
    title: "Unmatched Basketball",
    description: "Unmatched Basketball is a thrilling 3v3 third-person basketball experience.",
    category: "Other",
    rating: 4.030745364242178,
    plays: 2,
    path: "/public/games/unity-1777353828014-unmatched-basketball/index.html",
  },
  {
    id: "unity-1777353835402-hoop-world-3d",
    title: "Hoop World 3D",
    description: "Hoop World 3D is a flip-and-dunk game that brings basketball to a whole new dimension!",
    category: "Other",
    rating: 4.831251513062908,
    plays: 2,
    path: "/public/games/unity-1777353835402-hoop-world-3d/index.html",
  },
  {
    id: "unity-1777353845114-basketball-skills",
    title: "Basketball Skills",
    description: "Basketball Skills is the basketball arcade game in which you must try to score baskets in all the different game modes available.",
    category: "Other",
    rating: 4.743041598987272,
    plays: 2,
    path: "/public/games/unity-1777353845114-basketball-skills/index.html",
  },
  {
    id: "unity-1777353848644-ragdoll-throw-challenge",
    title: "Ragdoll Throw Challenge",
    description: "Ragdoll Throw Challenge is a physics-based casual game where you control a wobbly character and fling them at your enemies!",
    category: "Other",
    rating: 4.305988427018703,
    plays: 2,
    path: "/public/games/unity-1777353848644-ragdoll-throw-challenge/index.html",
  },
];

// Available categories for filtering
export const categories = [
  "All",
  "Action",
  "Adventure",
  "Puzzle",
  "Racing",
  "Sports",
  "Strategy",
  "Multiplayer",
  "Idle",
  ".IO",
  "Shooter",
  "Arcade",
  "Other",
];

// Alias for compatibility
export const allGames = games;
